import React from "react";
import Box from "../../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../../services/Notify";
import Loading from "../../component/Loading/Loading";
import FormButtons from "../../component/Form/FormButtons";
import NodeService from "../node/NodeService";
import NodeSelector from "./NodeSelector";
import ActionMomentSelector from "./ActionMomentSelector";
import HttpRequest from "../../services/HttpRequest";

class NodeActionForm extends React.Component {

  service = new NodeService();

  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
  }

  submitForm() {

    const entity = {
      actionNameDTO: this.actionNameDTO,
      nodeTargetIds: [this.node]
    };

    this.setState({loading: true, message: 'Salvando...'});

    new HttpRequest().post(`/cloud/v1/nodes/${this.node}/actions`, entity).then(
      () => {
        this.props.history.goBack();
        Notify.success('Entidade salva');
      },
      (error) => {
        Notify.error('Falha ao salvar entidade:', error);
        this.setState({loading: false, entity, message: null});
      });
  }

  onChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.state.isIntegrated = value;
    this.setState(this.state);
  }

  render() {
    const {loading, entity, message} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    return (
      <Box info>
        <form ref={form => (this.form = form)} onSubmit={event => {
          event.preventDefault();
          this.submitForm()
        }}>

          <NodeSelector required={true}
                        setValue={value => this.node = value}/>

          <ActionMomentSelector required={true}
                                setValue={value => this.actionNameDTO = value}/>

          {/*<InputWithLabel*/}
          {/*  label="Nome"*/}
          {/*  inputType="text"*/}
          {/*  onChange={e => this.friendlyName = e.target.value}*/}
          {/*  defaultValue={entity && entity.friendlyName}*/}
          {/*/>*/}

          {/*<InputWithLabel*/}
          {/*  label="Descrição"*/}
          {/*  inputType="text"*/}
          {/*  onChange={e => this.description = e.target.value}*/}
          {/*  defaultValue={entity && entity.description}*/}
          {/*/>*/}

          {/*<InputWithLabel*/}
          {/*  label="Agrupador"*/}
          {/*  inputType="text"*/}
          {/*  onChange={e => this.rpGroup = e.target.value}*/}
          {/*  defaultValue={entity && entity.rpGroup}*/}
          {/*/>*/}

          {/*<ReadpointMomentReadSelector defaultValue={entity && entity.momentRead} setValue={x => this.momentRead = x}/>*/}

          {/*<ReadpointTypeSelector required={true}*/}
          {/*                       defaultValue={entity && entity.type}*/}
          {/*                       setValue={value => this.type = value}/>*/}

          <FormButtons history={this.props.history}/>
        </form>
      </Box>)
      ;
  }
}

NodeActionForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default NodeActionForm;



// WEBPACK FOOTER //
// ./src/gateways/component/NodeActionForm.js